// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__MegOb","errorLogs":"EditorFooter_errorLogs__2SHLp"};